import React, { useState } from "react";
import faqimg from "../assets/OBJECTS.png";
import "../App.css";

const FAQItem = ({ question, answer, isOpen, toggle }) => {
  return (
    <div
      className={`faq-item rounded mb-3 ${isOpen ? "open" : ""}`}
      style={{
        boxShadow: "0 1px 6px rgba(0, 0, 0, 0.1)",
        background: "rgba(255, 255, 255, 0.95)",
        borderRadius: "6px",
      }}
    >
      <button
        onClick={toggle}
        className="btn  w-100 text-start d-flex justify-content-between align-items-center"
        aria-expanded={isOpen}
        style={{
          fontWeight: isOpen ? "600" : "400",
          color: isOpen ? "#F2664A" : "#000",
        }}
      >
        <span>{question}</span>
        <span
          style={{
            display: "inline-block",
            transform: isOpen ? "rotate(0deg)" : "rotate(180deg)",
            transition: "0.3s ease",
            fontSize: "1.25rem",
            fontWeight: "100",
            lineHeight: 1,
          }}
        >
          <i class="fa-solid fa-angle-down"></i>
        </span>
      </button>
      {isOpen && (
        <div className="p-3" style={{ fontSize: "0.9rem" }}>
          {typeof answer === "string" && <p className="mb-0">{answer}</p>}

          {Array.isArray(answer) && (
            <ul className="mb-0 ps-3">
              {answer.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          )}

          {typeof answer === "object" && !Array.isArray(answer) && (
            <>
              <p className="mb-2">{answer.intro}</p>
              <ul className="mb-0 ps-3">
                {answer.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
};

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      question: "Can AEPS be used for business or merchant payments?",
      answer:
        "AEPS is mainly designed for basic banking services, not for merchant bill payments or online purchases.",
    },
    {
      question: "Is Aadhaar mandatory for AEPS?",
      answer:
        "Yes. Aadhaar is mandatory, and it must be linked to the customer’s bank account.",
    },
    {
      question: "How can I check my AEPS transaction status?",
      answer:
        "You can check the status through the AEPS agent, service provider portal, or by contacting customer support with the transaction reference number.",
    },
    {
      question: "Is a debit card or PIN required for AEPS?",
      answer:
        "No. AEPS transactions are completed using Aadhaar number and biometric authentication (fingerprint).",
    },
    {
      question: "Which banks support AEPS?",
      answer:
        "Most major Indian banks support AEPS. Availability depends on whether the customer’s Aadhaar is linked to their bank account.",
    },
    {
      question: "What details are required to use AEPS?",
      answer: [
        "Aadhaar Number",
        "Bank Name",
        "Biometric Authentication (Fingerprint)",
      ],
    },
    {
      question: "Can AEPS transactions fail?",
      answer: {
        intro: "Yes, transactions may fail due to:",
        points: [
          "Biometric mismatch",
          "Aadhaar not linked to bank account",
          "Bank server issues",
          "Poor internet connectivity",
        ],
      },
    },
  ];

  return (
    <div className="container py-lg-5 py-3 " id="faq">
      <div className="row align-items-center">
        <h2 className="mb-4" style={{ fontWeight: "bold" }}>
          <span className="text-danger">Frequently</span> Asked Questions
        </h2>
        {/* Left: FAQ title and illustration */}
        <div className="col-md-6 d-flex flex-column align-items-center align-items-md-start text-center text-md-start mb-5 mb-md-0">
          <img
            src={faqimg}
            alt="FAQ Illustration"
            className="img-fluid faq-image"
          />
        </div>

        {/* Right: FAQ accordion */}
        <div className="col-md-6">
          <div className="">
            {faqs.map((faq, i) => (
              <FAQItem
                key={i}
                question={faq.question}
                answer={faq.answer}
                isOpen={openIndex === i}
                toggle={() => setOpenIndex(openIndex === i ? -1 : i)}
              />
            ))}
            {/* faq-2*/}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
